import React from "react";
import {useSelector} from "react-redux";
import styles from "./MainHeader.module.scss";
import {Link} from 'react-router-dom';
import ServicesHeader from "./ServicesHeader";
import ConnectorSettingsMenu from "./headerMenus/ConnectorSettingsMenu";
import WorkspaceMenu from "./headerMenus/WorkspaceMenu";
import UserMenu from "./headerMenus/UserMenu";
import AccountMenu from "./headerMenus/AccountMenu";
import HelpMenu from "./headerMenus/HelpMenu";
import NotificationsMenu from "modules/notifications/components/NotificationsMenu"
import ConnectorMenu from "./headerMenus/ConnectorMenu";
import {PopoverContext} from "ui-components-rollup/dist/Popover";
import { Tag } from "ui-components-rollup";

export default React.memo(() => {
    const isDemo = useSelector(state => state.tenancy.isDemo);
    const selectedAccount = useSelector(state => state.tenancy.selectedAccount);

    return (<PopoverContext Component="header" className={styles['container']}>
        <div className={styles['primary']}>
            <div className={styles["title"]}>
                {isDemo && <Tag className={styles.demo} level={12} color="light-blue">Demo</Tag>}
                <Link className={styles['main-link']} to="/">Cloud Manager</Link>
            </div>
            <div className={styles['menu-widgets']}>
                <AccountMenu/>
                <WorkspaceMenu/>
                <ConnectorMenu/>
                {process.env.REACT_APP_IS_DARK !== "true" && selectedAccount && <NotificationsMenu/>}
                <ConnectorSettingsMenu/>
                <HelpMenu/>
                <UserMenu/>
            </div>
        </div>
        {selectedAccount && <ServicesHeader/>}
    </PopoverContext>)
});
